import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Link } from "react-router-dom";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snap = await getDocs(collection(db, "categories"));
        const list = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCategories(list);
      } catch (err) {
        console.error("カテゴリ取得失敗:", err);
      }
    };

    fetchCategories();
  }, []);

  if (categories.length === 0) return <p>カテゴリがありません</p>;

  return (
    <ul>
      {categories.map(cat => (
        <li key={cat.id}>
          <Link to={`/library?category=${cat.name}`}>{cat.name}</Link>
        </li>
      ))}
    </ul>
  );
};

export default CategoryList;
